import { IllustrationName } from '@pandiafi/design-system'
import { StatusView } from '@pandiafi/components'
import React from 'react'

import { ResidentAppIllustration } from 'components/ResidentAppIllustration'

interface EmptyStateProps {
  title: string
  description?: string
  illustration?: IllustrationName
  /** One below the surrounding heading, e.g. 3 inside a titled card */
  headingLevel?: 2 | 3 | 4
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  illustration = 'empty-letter',
  headingLevel = 3,
}) => {
  return (
    <StatusView
      variant="empty"
      title={title}
      headingLevel={headingLevel}
      illustration={<ResidentAppIllustration name={illustration} alt="" />}
    >
      {description}
    </StatusView>
  )
}
